import React from 'react';
import Title from './Title';
import './container.css';


export default function Container(props){

    const {id, text} = props;

    function content(id){
        switch(id){
            case 'about':
                return(
                    <div className="Container_main_content">
                        <p>Expert professional with more than 20 years of experience.</p>
                        <p>In 2003, I founded an advertising company In which I was still connected to technology, developing web applications. In 2009, I added to my portfolio mobile development for iOS and Android. Nowadays I prefer to focus on Python language as I became an AI enthusiast attending some courses and trying some experiments.</p>
                        <p>Technologies I have already worked with:</p>
                        <p>Objective C & Swift - iOS, Java - Android, Html, Css, JavaScript/JQuery, React, Asp, C#, C (Arduíno), Python.</p>
                        <p>I'm also familiar with cloud platforms such as AWS and Google Cloud.</p>
                        <p>In my recent jobs at Coddera Software and Prototype Ideas, as a team member, I dealt with products from Google Cloud as App Engine, Cloud Storage, Cloud Functions, Cloud Scheduler, MySql databases, Cloud PubSub, Load balancer and Dialog Flow and Amazon Web Services like S3, SNS, SQS, DynamoDB, Elastic Cache (Redis), Lambda, API Gateway, Cognito.</p>
                        <p>At Neurotrack I have the opportunity to work with AWS again and learn about resources like serverless framework to easily deploy our projects.</p>
                        <p>At Lululemon I was introduced to Terraform for setting infrastructure configuration at AWS</p>
                        <p>I spend my free time as an airplane private pilot, cycling, studying algorithms, music and electronics.</p>
                    </div>
                );
            case 'highlights':
                return(
                    <div className="Container_main_content">
                        <p>I can work with different languages, and that’s why I believe companies believe in my work and potential. I have ease in dealing with new technologies and constantly updating my skills with those I am familiar with.</p>
                        <p>I´m always interested in improving my knowledge and find new challenges.</p>
                    </div>
                );
            case 'tech_summary':
                return(
                    <div className="Container_main_content">
                        <p><span className="Container_main_content_subtitle">Software:</span> Flask, React, Axios, Bootsrap, Reactstrap, Selenium, AWS Lambda Functions, AWS SNS, AWS SQS, AWS Api Gateway, AWS Databases, AWS Elastic Search, Google Cloud App Engine, Google Cloud Functions, Google Cloud Storage, Google Cloud Scheduler, Google Cloud PubSub, Google Cloud Load Balancer, Google Domains, Google Dialog Flow, Postman, Zenvia</p>
                        <p><span className="Container_main_content_subtitle">Languages:</span> Javascript, JQuery, C#, Python, Html, Css</p>
                        <p><span className="Container_main_content_subtitle">Project Management Tools:</span> Github, Bitbucket, Trello, Pivotal, Figma</p>
                        <p><span className="Container_main_content_subtitle">Databases:</span> SQL Server, MySQL, SQLlite</p>
                        <p><span className="Container_main_content_subtitle">Hardware</span>: Raspberry Pi, Arduino</p>
                        <p><span className="Container_main_content_subtitle">Applications:</span></p>
                        <ul>
                            <li>Lululemon (Python, terraform framework, AWS Lambda, AWS DynamoDB, Scheduled Events, pytest, Gitlab CI/CD)</li>
                            <li>Neurotrack (Python, serverless framework, AWS Lambda, AWS DynamoDB, AWS SNS, pytest)</li>
                            <li>Josie (Prototype Ideas, Python, Flask, Dialog Flow, Zenvia Whatsapp integration)</li>
                            <li>E.I.T.A. - app.eita.me (Prototype Ideas, React, Python, Flask backend)</li>
                            <li>Saude Aqui (Prototype Ideas, Python & Flask backend for mobile apps)</li>
                            <li>Cash Edu (Prototype Ideas, Python & Flask backend for mobile apps)</li>
                            <li>M.O.E (Coddera Software, C# & Selenium for process automation)</li>
                            <li>Liberty Seguros (iOS & Android App)</li>
                            <li>Morpheus System (Boxnet, C# ASP.NET Core, AWS)</li>
                            <li>Yio Digital (React, Python & Flask)</li>
                            <li>Estacione (iOS Swift, Android Java, ASP.NET C#)</li>
                            <li>Deputados (iOS Swift)</li>
                            <li>FlappCmsApp (ASP.NET C# and WEB API for mobile/server communications)</li>
                            <li>Safepark (iOS Swift, ASP.NET C#)</li>
                        </ul>
                        <p><span className="Container_main_content_subtitle">Industries:</span> Laboratórios Fleury (Health Exams), DASA (Health Exams), Euroimmun (Laboratory supplies), Liberty Seguros (Insurance), Boxnet (News monitoring for Companies and Government), EITA (Neuroscience Consultance), Yio Digital (Retail Campaigns), Parking Lots, Cash Edu (Education), Saude Aqui (Health), Neurotrack (Health), Lululemon (Retail)</p>
                        <p><span className="Container_main_content_subtitle">Operating Systems:</span> Windows, MacOS, Linux</p>
                        <p><span className="Container_main_content_subtitle">Methodologies:</span> Scrum</p>
                    </div>
                );
            case 'experience':
                return(
                    <div className="Container_main_content">
                        <p className="Container_experience_title"><span>LULULEMON</span><span>Vancouver, Canada</span><span>May. 2022 – 'til now</span></p>
                        <p className="Container_main_content_subtitle">Senior Backend Engineer</p>
                        <p>I have participated in defining project's architecture, developing backend code, and providing resources configuration for AWS using Terraform and Gitlab pipelines.</p>
                        <p><span className="Container_main_content_subtitle">Responsibilities:</span></p>
                        <ul>
                            <li>Code backend in python.</li>
                            <li>Mock services using Nodejs running in docker containers at AWS</li>
                            <li>Get assigned issues in Jira and solve them.</li>
                            <li>Interact with Github, Gitlab, do code reviews, pull requests and pipelines setup.</li>
                            <li>Develop some new features and integrations with external APIs.</li>
                            <li>Deploy services infrastructure configuration using Terraform.</li>
                            <li>Write unit tests using pytest library.</li>
                        </ul>

                        <hr />
                        
                        <p className="Container_experience_title"><span>NEUROTRACK</span><span>Vancouver, Canada</span><span>Nov. 2021 – May 2022</span></p>
                        <p className="Container_main_content_subtitle">Senior Backend Engineer</p>
                        <p>I was responsible for defining the project's architecture, developing backend code, and providing resources configuration for AWS using serverless framework.</p>
                        <p><span className="Container_main_content_subtitle">Responsibilities:</span></p>
                        <ul>
                            <li>Code backend in python.</li>
                            <li>Get assigned issues in Jira and solve them.</li>
                            <li>Interact with Github, do code reviews, pull requests.</li>
                            <li>Develop some new features and integrations with external APIs.</li>
                            <li>Deploy services using the serverless framework.</li>
                            <li>Write unit tests using pytest library.</li>
                        </ul>

                        <hr />

                        <p className="Container_experience_title"><span>PROTOTYPE IDEAS</span><span>São Paulo, Brazil</span><span>Jan. 2020 – Apr. 2021</span></p>
                        <p className="Container_main_content_subtitle">Senior Full Stack Software Developer & Tech Leader</p>
                        <p>I was responsible for defining the project's architecture, developing the front and backend, and providing resources configuration in Google Cloud Platform.</p>
                        <p><span className="Container_main_content_subtitle">Responsibilities:</span></p>
                        <ul>
                            <li>Frontend: I used Figma as the reference to translate the designed interface into code.</li>
                            <li>Created each project in Google Cloud and configured all resources needed for each one.</li>
                            <li>Designed databases, procedures and functions for each application.</li>
                            <li>As a tech leader, I was also designated to recruit new developers and train them.</li>
                            <li>Estimated costs for each project.</li>
                            <li>Participated in daily SCRUM meetings.</li>
                            <li>Developed applications frontend in ReactJS and published them in Google Cloud Storage.</li>
                            <li>Developed applications backend in Python and published in Google App Engine in the cloud.</li>
                        </ul>

                        <hr />

                        <p className="Container_experience_title"><span>CODDERA SOFTWARE/BOXNET SERVIÇOS</span><span>São Paulo, Brazil</span><span>Ago. 2018 – Set. 2019</span></p>
                        <p className="Container_main_content_subtitle">Senior Back-end Software Developer</p>
                        <p>I was a Coddera employee and was relocated to Boxnet for 1 year with other 3 team members. With the team I was the leader, I developed the project called Morpheus that was running in AWS platform using lambda functions, API Gateway, Elastic Search, MySQL Database, SNS, SQS, and S3 Storage. </p>
                        <p><span className="Container_main_content_subtitle">Responsibilities:</span></p>
                        <ul>
                            <li>Be one of those who were creating and delivering back-end code to serve web applications. These back-end codes were all running in AWS Lambda Functions.</li>
                            <li>As we had a period without a front-end developer, about a month, I got ahead of the front-end development in VUE to keep the project going on.</li>
                            <li>Discussed features and help to define how they should be developed</li>
                            <li>Participated in daily scrum meetings and in meetings with the company board to understand their needs about the project</li>
                            <li>Wrote code in C# ASP.NET Core 2.1 to be compatible with AWS Lambda Functions and publish</li>
                        </ul>

                        <hr />

                        <p className="Container_experience_title"><span>CODDERA SOFTWARE</span><span>São Paulo, Brazil</span><span>Jan. 2017 – Nov. 2019</span></p>
                        <p className="Container_main_content_subtitle">Senior Full Stack Software Developer</p>
                        <p>In the beginning, I should be joining Coddera for two months to substitute one of the employees who were out for a holiday but in the end, I stayed for more than two years working mainly on an automation project called M.O.E. M.O.E is a bot created with Selenium to substitute people in a process.</p>
                        <p><span className="Container_main_content_subtitle">Responsibilities:</span></p>
                        <ul>
                            <li>Maintained the bots running in clients and updatee code fixing bugs and creating new features</li>
                            <li>Answered the client needs and participated in meeting with clients</li>
                            <li>Supported and maintained SQL Server database for M.O.E running in client</li>
                            <li>In M.O.E project the code was in C# ASP.NET and was published in a private environment in a Windows Server through Remote Access</li>
                            <li>I also worked part of the time supporting projects in Java but I confess that Java is not my favorite language to code.</li>
                            <li>At Coddera I could also update some mobile projects in iOS and Android and could create some POC (proof of concepts).</li>
                        </ul>

                        <hr />

                        <p className="Container_experience_title"><span>FLAPP MOBILE</span><span>São Paulo, Brazil</span><span>Oct. 2009 – May. 2021</span></p>
                        <p className="Container_main_content_subtitle">Full Stack Software Developer</p>
                        <p>Is the company I owned in Brazil where I develop my own projects and sometimes for private clients. This company was also the way through I could make experiments like in IoT area.</p>
                        <p><span className="Container_main_content_subtitle">Responsibilities:</span></p>
                        <ul>
                            <li>Contacted clients, understood their needs and created business proposals</li>
                            <li>Coded for iOS, Android and Web</li>
                            <li>Created databases as SQL Server, MySQL and SQLite</li>
                        </ul>

                        <hr />

                        <p className="Container_experience_title"><span>GARAPA COMUNICAÇÃO</span><span>São Paulo, Brazil</span><span>Jul. 2003 – Oct. 2009</span></p>
                        <p className="Container_main_content_subtitle">Full Stack Software Developer</p>
                        <p>Garapa was an advertising agency I owned with two other partners.</p>
                        <p><span className="Container_main_content_subtitle">Responsibilities:</span></p>
                        <ul>
                            <li>Contacted clients, understood their needs and created business proposals</li>
                            <li>Coded in ASP, Flash (Action Script), HTML, CSS, created databases as SQL Server and MySQL</li>
                        </ul>
                    </div>
                );
            case 'education':
                return(
                    <div className="Container_main_content">
                        <p className="Container_experience_title"><span>FIAP (fiap.com.br), São Paulo, Brazil</span></p>
                        <p>Artificial Intelligence and Machine Learning</p>
                        <p>Mar. 2019 - Mar. 2020</p>

                        <hr />

                        <p className="Container_experience_title"><span>SENAI (sp.senai.br), São Paulo, Brazil</span></p>
                        <p>Internet of Things</p>
                        <p>Jan. 2017 - Jun. 2018</p>

                        <hr />

                        <p className="Container_experience_title"><span>BANDTEC (digitalschool.com.br), São Paulo, Brazil</span></p>
                        <p>System Analysis and Development</p>
                        <p>Aug. 2014 - Dec. 2016</p>
                    </div>
                );
            case 'contact':
                return(
                    <div className="Container_main_content">
                        <p>Feel free to contact-me on marco.chaddoud@gmail.com</p>
                        <p>or add me in your LinkedIn network - linkedin.com/in/chaddoud</p>
                    </div>
                );
            default:
                return;
        }
    }

    return(
        <div id={id} className="Container_main">
            <Title text={text} />
            {content(id)}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/Container.js